import axios from "axios";
import axiosRetry from 'axios-retry';
import interceptor from "./interceptor";

let credentials = false;
const interceptorAxios = interceptor();

const api = axios.create({
  withCredentials: credentials,
  timeout: 90000,
});

const retryDelay = () => {
  const seconds = 5000;
  return seconds;
};

axiosRetry(api, {
  retries: 1,
  retryDelay,
  retryCondition: (error) => isNetworkError(error),
});

const isNetworkError = (error) => {
  console.log(`error: ${error?.code}`);
  console.log(`RETRY ERROR: ${error}`);
  return (
    error?.code == 'ECONNABORTED' ||
    JSON.stringify(error).includes('Network Error')
  );
};

// eslint-disable-next-line no-console

api.interceptors.request.use((config) => {
  return interceptorAxios.onRequest(config);
});
api.interceptors.response.use(interceptorAxios?.onResponseSuccess, interceptorAxios?.onResponseError);

export default api;
